// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"07545753","977":"b4d1694d"}[chunkId] + ".chunk.js";
};